export default __webpack_public_path__ + "static/media/46-CDS-Bravura.f080f88c.jpg";